import { render, staticRenderFns } from "./LastInspections.vue?vue&type=template&id=ef934ba0&scoped=true"
import script from "./LastInspections.vue?vue&type=script&lang=js"
export * from "./LastInspections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef934ba0",
  null
  
)

export default component.exports